export type FrontendMode = 'aws' | 'demo';

export const FRONTEND_MODE: FrontendMode =
  process.env.REACT_APP_FRONTEND_MODE === 'aws' ? 'aws' : 'demo';

export const IS_AWS_MODE = FRONTEND_MODE === 'aws';
export const FRONTEND_MODE_BADGE = IS_AWS_MODE ? 'Connecté AWS DEV' : 'Données simulées';

export const AWS_NAVIGATION_PATHS = [
  '/dashboard',
  '/iot',
  '/devices',
  '/alerts',
  '/documentation',
] as const;

export const isPathEnabled = (path: string, mode: FrontendMode = FRONTEND_MODE): boolean =>
  mode === 'demo' || (AWS_NAVIGATION_PATHS as readonly string[]).includes(path);

export const isTtnSimulatorEnabled = (
  value = process.env.REACT_APP_ENABLE_TTN_SIMULATOR,
): boolean => value === 'true';

export const isTelemetryEnabled = (
  value = process.env.REACT_APP_TELEMETRY_BACKEND,
): boolean => value !== 'disabled';

export const supportsValveControl = (model: string): boolean =>
  model === 'valve_water_flow';
